import React from "react";
import { AiFillFacebook, AiFillInstagram } from "react-icons/ai";
import { getLinkedSocialEntry, hasLinkedSocialProfiles } from "../../utils/socialProfileLinks";

const platformConfig = {
  facebook: {
    label: "View Facebook Profile",
    Icon: AiFillFacebook,
    className:
      "border-[#1877F2]/30 bg-[#1877F2]/10 text-[#1877F2] hover:bg-[#1877F2]/15",
  },
  instagram: {
    label: "View Instagram Profile",
    Icon: AiFillInstagram,
    className:
      "border-[#dd2a7b]/30 bg-gradient-to-r from-[#f58529]/10 via-[#dd2a7b]/10 to-[#8134af]/10 text-[#c13584] hover:opacity-90",
  },
};

const SocialProfileBadges = ({
  profiles,
  className = "",
  compact = false,
  title = "Social profiles",
}) => {
  if (!hasLinkedSocialProfiles(profiles)) return null;

  return (
    <div className={className}>
      {!compact ? (
        <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-slate-500">
          {title}
        </p>
      ) : null}
      <div className={`flex flex-wrap gap-2 ${compact ? "" : "mt-1"}`}>
        {["facebook", "instagram"].map((platform) => {
          const entry = getLinkedSocialEntry(profiles, platform);
          if (!entry) return null;
          const { Icon, className: badgeClass, label } = platformConfig[platform];
          return (
            <a
              key={platform}
              href={entry.profileUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={`inline-flex items-center gap-1.5 rounded-lg border px-3 py-2 text-xs font-semibold transition ${badgeClass}`}
              title={label}
            >
              <Icon size={16} />
              <span>{label}</span>
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default SocialProfileBadges;
